import { useEffect } from 'react';
import { useSSE } from '../geral/SSEContext';

export const useWhatsappWebSSE = ({
  extrairContatoDoEvento,
  processarContatoRecebido,
  sincronizarSeNecessario,
}) => {
  const { subscribeToEvent } = useSSE();

  useEffect(() => {
    const unsubscribePedido = subscribeToEvent('chat-contato', async (event) => {
      try {
        const payload = JSON.parse(event.data);
        const contatoEvento = extrairContatoDoEvento(payload);

        if (contatoEvento) {
          await processarContatoRecebido(contatoEvento);
          return;
        }

        sincronizarSeNecessario().catch(() => {});
      } catch (error) {
        console.error('Erro ao processar SSE de chat-contato:', error, event.data);
        sincronizarSeNecessario().catch(() => {});
      }
    });

    return unsubscribePedido;
  }, [extrairContatoDoEvento, processarContatoRecebido, sincronizarSeNecessario, subscribeToEvent]);
};
